import axios from 'axios';
import API_BASE_URL from '../config'; // Importa la URL base de la API

const rankingForEventServices = async (idEvent) => {
  const tokeUser = localStorage.getItem('token');

  try {
    const response = await axios.get(`${API_BASE_URL}/ranking/event/${idEvent}/`);
    return response.data;
  } catch (error) {
    throw new Error('Error fetching user ranking');
  }
};

export default rankingForEventServices;
